import { TDashboardItem } from "@/data/types";

export interface DashboardsState {
  items: TDashboardItem[];
  currentDashboard: TDashboardItem | null;
}

export const DefaultDashboardsState: DashboardsState = {
  items: [],
  currentDashboard: null,
};